import { TaskIngredientView, ProductDetails, graphneAPI } from '@nexelem/graphne-api';
import { createTableInfiniteDataSource } from '@nexelem/tanstack-table';

export type BillOfMaterialDataSourceResult = {
  result: {
    data?: TaskIngredientView[];
    total: number;
    productDetails: ProductDetails;
    taskName: string;
  };
};

export const createBillOfMaterialDataSource = (taskId: string) =>
  createTableInfiniteDataSource({
    queryKey: ['bill-of-material', taskId],
    queryFn: () =>
      graphneAPI.getGraphneTasksTaskidIngredients({ taskId }).then(
        (res) =>
          ({
            result: {
              data: res.ingredients,
              total: res.ingredients?.length ?? 0,
              productDetails: res.productDetails,
              taskName: res.taskName,
            },
          }) satisfies BillOfMaterialDataSourceResult,
      ),
  });
